 import req from '@/utils/req.js'

 //关键字分页列表
 export function replyList(params) {
   return req.post(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/page`, params)
 }
 //关键字详情
 export function getReplyDetails(params) {
   return req.get(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/${params}`)
 }
 //删除
 export function delReply(params) {
   return req.delete(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/${params}`)
 }
 //获取素材
 export function getMaterial(params) {
   return req.get(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/getMaterial`, params)
 }
 //关键字回复保存
 export function saveReply(params) {
   return req.post(`/dsicm-contact-platform/feign/wechat-public-automatic-reply`, params)
 }
  //关键字回复保存 返回id
  export function saveReplyReturnId(params) {
    return req.post(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/insertReturnId`, params)
  }
 
 // 编辑 
 export function editeReply(params) {
   return req.put(`/dsicm-contact-platform/feign/wechat-public-automatic-reply`, params)
 }
// 关注回复-收到消息回复详情

export function getDetailsByType(params) {
  return req.get(`/dsicm-contact-platform/feign/wechat-public-automatic-reply/detail-by-reply-type`, params)
}

//关注回复二维码
export function getQrCodePublic(params) {
  return req.post("/admin/doctor-team-qrcode/getQrCodePublicReply",params);
}
//分页获取病种 
export function getDiseasetype(params) {
  return req.post("/admin/disease-type/page",params);
}
//分页获取机构名称 
export function getHospital(params) {
  return req.post("/admin/hospital/search",params);
}
//分页获取机构名称 
export function updatePublicReply(params) {
  return req.post("/dsicm-contact-platform/wechat-public-reply/updatePublicReply",params);
}
// 根据科室获取团队 
export function getTeamByDepart(params) {
  return req.post("/admin/doctor-team/pageDoctorTeamForOpenDepartmentIds",params);
}

//批量更新回复
export function batchUpdatePublicReply(params) {
  return req.post("/dsicm-contact-platform/wechat-public-reply/batchUpdatePublicReply",params);
} 
//获取医生
export function getDoctorByQrcode(params) {
  return req.post("/admin/doctor-team-qrcode/pageQrCodeInfo",params);
}
//获取拉C人
export function getPromoterUser(params) {
  return req.post("/dsicm-contact-platform/wechat-public-reply/getPromoterUserInfo",params);
}

